module.exports = __webpack_public_path__ + "img/vacuo.4dacc482.jpg";